export enum CardValidityType {
  FROM_TO = 'FromTo',
  EXPIRY_AFTERSALE = 'ExpiryAfterSale',
  EXPIRY_AFTER_FIRST_USAGE = 'ExpiryAfterFirstUsage',
}
